import { useCallback, useEffect, useState } from 'react';

import { generateRunSummaryAgentReport } from '../../../../services/activeRunsService';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAgentSummary,
  selectReportData,
  selectRunSummaryFilters,
  resetAgentSummary,
  resetReportData,
  setAgentSummary,
  setReportData,
} from '../../../../redux/runSummary/runSummarySlice';

export default function useRunSummaryAgentReport() {
  const dispatch = useDispatch();
  const [report, setReport] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportError, setReportError] = useState(null);
  const filters = useSelector(selectRunSummaryFilters);
  const reportData = useSelector(selectReportData);
  const agentSummary = useSelector(selectAgentSummary);

  useEffect(() => {
    setReport(null);
    setReportError(null);
    dispatch(resetAgentSummary());
    dispatch(resetReportData());
  }, [dispatch, filters]);

  const generateReport = useCallback(async () => {
    setReportLoading(true);
    setReportError(null);

    try {
      const response = await generateRunSummaryAgentReport(filters);
      dispatch(setAgentSummary(response.agent_data.graphics));
      dispatch(setReportData(response.agent_data.visuals));
      setReport(response.report_data);
    } catch (error) {
      setReportError(error.message || 'Failed to generate run summary report.');
    } finally {
      setReportLoading(false);
    }
  }, [dispatch, filters]);

  return {
    generateReport,
    agentSummary,
    report,
    reportError,
    reportLoading,
    reportData,
  };
}
